import { makeStyles } from "@material-ui/core/styles";
// Scoped to these settings pages; respects the selected light/dark theme.
export default makeStyles(theme => ({
  root: {
    color: theme.palette.text.primary,
    "& .MuiTypography-root:not(.MuiTypography-colorError):not(.MuiTypography-colorPrimary):not(.MuiTypography-colorSecondary):not(.MuiTypography-colorTextSecondary)": { color: `${theme.palette.text.primary} !important` },
    "& .MuiTypography-colorTextSecondary": { color: `${theme.palette.text.secondary} !important` },
    "& a": { color: theme.palette.primary.main }
  }
}));
